import { Injectable } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "./common.service";

@Injectable({ providedIn: "root" })
export class ModalWrapperService {
    // Listen for ESC key to close the topmost modal
    private escListener: any;

    // Stack to track open modals
    private modalStack: NgbModalRef[] = [];

    constructor(private modalService: NgbModal, private _commonService: CommonService) {
        // Attach global ESC key listener
        if (!this.escListener) {
            this.escListener = (event: KeyboardEvent) => {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    if (this.modalStack.length > 0) {
                        const topModal = this.modalStack[this.modalStack.length - 1];
                        if (topModal) {
                            if ((topModal as any).disableWrapperEsc || (topModal as any)?._windowCmptRef?.instance?.windowClass?.includes('modal-patient')) {
                                return; // Do nothing if disableWrapperEsc is true
                            }
                            if (topModal) {
                                topModal.close();
                            }
                        }
                    }
                }
            };
            window.addEventListener('keydown', this.escListener, true);
        }
    }

    open(content: any, options?: NgbModalOptions & { disableWrapperEsc?: boolean }): NgbModalRef {
        // Default to Esc-to-close; merge caller options safely and append window class when provided.
        const mergedOptions: NgbModalOptions = {
            ...options,
            keyboard: options?.keyboard !== undefined ? options.keyboard : true,
        };

        if (this.hasOpenModals()) {
            const standardCenterModals = document.getElementsByClassName('stand-center-modal-window');
            if (standardCenterModals.length > 0) {
                const modalWindowElement = standardCenterModals[0];
                const modalDialogElement = modalWindowElement.getElementsByClassName('modal-dialog')[0];
                mergedOptions.container = modalDialogElement as HTMLElement;
            } else {
                mergedOptions.container = document.getElementById('app-body-content');
                mergedOptions.windowClass = mergedOptions.windowClass
                    ? `${mergedOptions.windowClass} stand-center-modal-window`
                    : 'stand-center-modal-window';
            }
        } else {
            mergedOptions.container = document.getElementById('app-body-content');
            mergedOptions.windowClass = mergedOptions.windowClass
            ? `${mergedOptions.windowClass} stand-center-modal-window`
            : 'stand-center-modal-window';
        }
        mergedOptions.backdrop = 'static';
        this._commonService._modalViewChangeEvent$.next(true);
        const modalRef = this.modalService.open(content, mergedOptions);

        // Store disableWrapperEsc flag on modalRef
        (modalRef as any).disableWrapperEsc = options?.disableWrapperEsc;
        (modalRef as any).id = this.modalStack.length + 1;

        // Push to stack
        this.modalStack.push(modalRef);
        console.log('Modal opened. Current stack :', this.modalStack);
        // Remove from stack and notify when all modals are closed
        modalRef.result.finally(() => {
            this.modalStack = this.modalStack.filter(ref =>modalRef && ref &&  (ref as any).id !== (modalRef as any).id);
            if (this.modalStack.length === 0) {
                this._commonService._modalViewChangeEvent$.next(false);
            }
        });
        return modalRef;
    }

    hasOpenModals(): boolean {
        return this.modalService.hasOpenModals();
    }

    dismissAll(reason?: any): void {
        this._commonService._modalViewChangeEvent$.next(false);
        this.modalService.dismissAll(reason);
    }

    // Clean up listener if needed (optional, e.g. for ngOnDestroy)
    ngOnDestroy() {
        if (this.escListener) {
            window.removeEventListener('keydown', this.escListener, true);
            this.escListener = null;
        }
    }
}
